import { create } from 'zustand';
import { permsOf, ROUTE_PERM } from '../utils/perms';

const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token'),

  setAuth: (user, token) => {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
    set({ user, token });
  },

  /** v3.9: refresh the user (role / permissions changed by the admin) without logging out */
  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  },

  /** v3.9: true when the signed-in user has the permission (any of several: can('a', 'b')) */
  can: (...perms) => {
    const mine = permsOf(get().user);
    return perms.some(p => mine.includes(p));
  },

  canRoute: (path) => {
    const p = ROUTE_PERM['/' + (path || '').replace(/^\//, '').split('/')[0]];
    return !p || permsOf(get().user).includes(p);
  },

  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  hasRole: (roles) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return false;
    if (typeof roles === 'string') return user.role === roles;
    return roles.includes(user.role);
  },

  isAdmin: () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return user?.role === 'admin';
  },

  canEdit: (section) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (!user) return false;
    if (user.role === 'admin') return true;
    const permissions = {
      production: ['production_manager'],
      sales: ['sales_manager'],
      warehouse: ['production_manager'],
      lading: ['sales_manager'],
    };
    return permissions[section]?.includes(user.role) || false;
  },
}));

export default useAuthStore;
